<template>
  <div class="off_campus_internship_block">
    <div class="block_title">
      {{ college.college_name }}
    </div>
    <ul class="block_list row">
      <li
        v-for="(department) in college.departments"
        :key="department.department_id"
        class="block_item 奧col-md-3 col-sm-6 col-12"
      >
        <a :href="department.department_inter_link" target="_blank">{{ department.department_name }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'OffCampusInternshipBlock',
  props: {
    college: {
      type: Object,
      required: true
    }
  }
}
</script>
